export enum ServiceType {
  ServiceInspection = 'serviceInspection',
  EngineOil = 'engineOil',
  GearboxOil = 'gearboxOil',
  FourByFourOilDistributor = 'fourByFourOilDistributor',
  TimingBelt = 'timingBelt',
  BrakeFluid = 'brakeFluid',
  CoolantFluid = 'coolantFluid',
}
